<template>
  <div class="pagesMainDiv">

    <div class="pageHeader" style="margin-bottom: 15px;">
      <span class="pageHeader">Status Tracker </span><span  class="divRequiredInstructions">Searching is based on the parameters specified.</span>
    </div>

    <div class="formContainer formContainerBorder formContainerMargins">

      <!-- --------------------------------------------- -->
      <!-- ------------ left column -------------------- -->
      <!-- --------------------------------------------- -->

      <div class="leftRightRowContainer">

        <!-- ----------------- Start Date -->
        <div class="itemHorRightVerCenter">
          <div class="labelRightMargin ctrlLabel fontSizeAll">Start Date:</div>
        </div>

        <div class="itemHorLeftVerCenter ">
          <input ID="StartDateID" type="date" class="ctrlBorderRadius ctrlDate fontSizeAll" v-model="SelectedStartDate" aria-label="Enter a Start Date"  aria-live="polite"/>
        </div>

        <!-- ----------------- First Name -->
        <div class="itemHorRightVerCenter">
          <div class="labelRightMargin ctrlLabel fontSizeAll">First Name:</div>
        </div>

        <div class="itemHorLeftVerCenter">
            <div>
                <label id="fnlbl" class="sr-only">First Name:</label>
                    <AcTextbox :OptionsList="firstNames" PlaceHolderText="Filter by First Name" :SelectedText="SelectedTextObj"
                               :ControlWidth="acCtrWidth" :TextboxStyle="acTextboxStyle" @itemSelected="handleFirstNameSelected" aria-labelledby="fnlbl" aria-label="Enter a First Name" aria-live="polite">
                    </AcTextbox>
                
            </div>
        </div>

        <!-- ----------------- Contract # -->
        <div class="itemHorRightVerCenter">
          <div class="labelRightMargin ctrlLabel fontSizeAll">Contract #:</div>
        </div>

        <div class="itemHorLeftVerCenter">
            <div>
                <label id="conlbl" class="sr-only">Contract #</label>
                    <AcTextbox :OptionsList="contractNumbers" PlaceHolderText="Filter by Contract Number"
                               :SelectedText="SelectedTextObj" :ControlWidth="acCtrWidth" :TextboxStyle="acTextboxStyle"
                               @itemSelected="handleContractSelected" aria-labelledby="conlbl" aria-live="polite">
                    </AcTextbox>
                    
            </div>
        </div>

        <!-- ---------- Action Controls ------ -->

        <div>&nbsp;</div>

        <div class="pageHeader">
          <button class="btn btn-primary btnCreateProperties fontSizeBtn" @click='handleSubmitSearchFunc' id="tbnSearchID"
            type="button">Search</button>

          <button class="btn btn-primary btnCreateProperties tbdButtonLeftMargin fontSizeBtn" @click='handleClearFunc' id="tbnClearID"
            type="button">Clear Search</button>
        </div>

      </div>

      <!-- --------------------------------------------- -->
      <!-- ------------ right column ------------------- -->
      <!-- --------------------------------------------- -->

      <div class="leftRightRowContainer">

        <!-- ----------------- End Date -->
        <div class="itemHorRightVerCenter">
          <div class="labelRightMargin ctrlLabel fontSizeAll">End Date:</div>
        </div>

        <div class="itemHorLeftVerCenter ">
          <input ID="StartDateID" type="date" class="ctrlBorderRadius ctrlDate fontSizeAll" v-model="SelectedEndDate" aria-label="Enter a End Date"  aria-live="polite"/>
        </div>

        <!-- ----------------- Last Name -->
        <div class="itemHorRightVerCenter">
          <div class="labelRightMargin ctrlLabel fontSizeAll">Last Name:</div>
        </div>

        <div class="itemHorLeftVerCenter">
            <div>
                <label id="lnlbl" class="sr-only">Last Name</label>
                    <AcTextbox :OptionsList="lastNames" PlaceHolderText="Filter by Last Name" :ControlWidth="acCtrWidth"
                               :SelectedText="SelectedTextObj" :TextboxStyle="acTextboxStyle" @itemSelected="handleLastNameSelected" aria-labelledby="lnlbl" aria-live="polite">
                    </AcTextbox>
                
            </div>
        </div>

        <!-- ------------------------- BLANK FIELD --------------------------- -->

        <div>&nbsp;</div>
        <div>&nbsp;</div>

      </div>
    </div>

    <!-- ---------------------------------------------------------------- -->
    <!-- --------------------------- Validation ------------------------- -->
    <!-- ---------------------------------------------------------------- -->

    <div v-if="validationErrorsFound" class="validationDiv">

      <div class="validationHeaderDiv">Form Validation</div>

      <table class="valTable valTableMargin">
        <tr>
          <td style="text-align: center" colspan="2" class="highlightDarkRed">The validation issues are the following:
          </td>
        </tr>
        <tr v-if="allFieldsAreNull">
          <td class="valCellLeft fontSizeAll">All Search Parameters</td>
          <td class="valCell fontSizeAll">All parameters are null. At least one is required.</td>
        </tr>
        <tr v-if="endBeforeStart">
          <td class="valCellLeft fontSizeAll">End Date less than Start Date</td>
          <td class="valCell fontSizeAll">End Date must be greater than or equal to Start Date.</td>
        </tr>
      </table>

    </div>

    <!-- --------------------------------------------------------------------- -->
    <!-- ------------------------- ApplicationGrid --------------------------- -->
    <!-- --------------------------------------------------------------------- -->

    <ApplicationGrid :GridData="gridTime" :EnablePaging="true" :EnableSearching="true" :EnableSorting="true"
      :HeaderArrays="headerArrays" :RowsPerPageArray="rowsPerPageArray" :EnableSettings="false"
      :EnableRecordsInfoDisplay="true">
    </ApplicationGrid>

  </div>

  <!-- ---------------------------------------------------------------- -->
  <!-- --------------------------- END -------------------------------- -->
  <!-- ---------------------------------------------------------------- -->
</template>
  
<script>
import axios from "axios";
import { store } from "../../../store/store.js";
import ApplicationGrid from "../../../components/dataSupport/ApplicationGrid.vue";
import AcTextbox from "../../../components/dataSupport/AcTextbox.vue";

export default {
  data() {
    return {
      store,

      // ------------- form --------------
      SelectedStartDate: null,
      SelectedEndDate: null,
      SelectedFirstName: null,
      SelectedLastName: null,
      SelectedContractNum: null,

      //The purpose of this is to be able to clear the text in the
      //AcTextbox control. Since the textbox in this control isn't
      //initialized to anything, the text value in the object is
      //null.
      SelectedTextObj: { text: null, time: new Date().getTime() },

      // ------------- grid -------------------
      gridTime: { grid: null, time: null },

      // ------------- source lists -------------------
      lastNames: null,
      firstNames: null,
      contractNumbers: null,

      // ------------- validation -------------------

      validationErrorsFound: false,
      allFieldsAreNull: false,
      endBeforeStart: false,

      headerArrays: [
        { defaultShow: false, rawName: 'statusTrackId', displayName: 'Tracker ID', hoverText: 'Record Primary Key' },
        { defaultShow: false, rawName: 'personID', displayName: 'Person ID', hoverText: 'Person ID' },        
        { defaultShow: true, rawName: 'firstName', displayName: 'First Name', hoverText: 'First Name' },
        { defaultShow: true, rawName: 'lastName', displayName: 'Last Name', hoverText: 'Last Name' },
        { defaultShow: true, rawName: 'armStatDisplay', displayName: 'Status', hoverText: 'Arming Status Display' },
        { defaultShow: false, rawName: 'contractId', displayName: 'Contract ID', hoverText: 'Contract ID' },        
        { defaultShow: true, rawName: 'contractNumber', displayName: 'Contract Number', hoverText: 'Contract Number' },
        { defaultShow: true, rawName: 'createDate', displayName: 'Updated', hoverText: 'Database Create Date' },
        { defaultShow: true, rawName: 'userEmail', displayName: 'Updated By', hoverText: 'User Email' },
        { defaultShow: false, rawName: 'suffix', displayName: 'Suffix', hoverText: 'User Suffix' },

        { defaultShow: false, rawName: 'companyId', displayName: 'Company ID', hoverText: 'Company ID' },        
        { defaultShow: false, rawName: 'companyName', displayName: 'Company Name', hoverText: 'Company Name' },  

        { defaultShow: false, rawName: 'agencyId', displayName: 'Agency ID', hoverText: 'Agency ID' },        
        { defaultShow: false, rawName: 'agencyName', displayName: 'Agency Name', hoverText: 'Agency Name' },        
      ],

      // -------------- property settings
      acCtrWidth: 300,
      acTextboxStyle: "width: 300px; border-radius: 6px; padding: 5px; height: 40px; border: 1px solid #d9d9d9",

    };
  },

  created() {

    this.getLastNames();
    this.getFirstNames();
    this.getContractNumbers();

  },

  computed: {},
  components: { ApplicationGrid, AcTextbox },
  methods: {

    // ---------------------------------------------------------------
    // ---------------------- Database Calls -------------------------
    // ---------------------------------------------------------------

    getLastNames() {
      axios
        .get(store.webAPIUrl + "tracker/GetLastNames")
        .then((response) => response.data)
        .then((data) => {
          this.$data.lastNames = data;

          // console.log(' ---> this.$data.gridAgencyNames = ', this.$data.gridAgencyNames);
        });
    },

    getFirstNames() {
      axios
        .get(store.webAPIUrl + "tracker/getFirstNames")
        .then((response) => response.data)
        .then((data) => {
          this.$data.firstNames = data;

          // console.log(' ---> this.$data.gridAgencyNames = ', this.$data.gridAgencyNames);
        });
    },

    getContractNumbers() {
      axios
        .get(store.webAPIUrl + "tracker/getContractNumbers")
        .then((response) => response.data)
        .then((data) => {
          this.$data.contractNumbers = data;

          // console.log(' ---> this.$data.gridAgencyNames = ', this.$data.gridAgencyNames);
        });
    },

    GetTrackerRecords() {

      let formData = new FormData();
      formData.append("StartDate",this.$data.SelectedStartDate);
      formData.append("EndDate",this.$data.SelectedEndDate);
      formData.append("FirstName",this.$data.SelectedFirstName);
      formData.append("LastName", this.$data.SelectedLastName);
      formData.append("ContractNumber",this.$data.SelectedContractNum);

      axios
        .post(store.webAPIUrl + "tracker/GetTrackerRecords", formData)
        .then((response) => response.data)
        .then((data) => {
          this.$data.gridTime = { grid: data, time: new Date().getTime() };
        });
    },
    
    GetTrackerRecordsClear() {
      //The time element in this object is important. Without it, the 
      //grids watch function may not be called.
      this.$data.gridTime = { grid: new Array(), time: new Date().getTime() };
    },

    // ---------------------------------------------------------------
    // ---------------------- Event Handlers -------------------------
    // ---------------------------------------------------------------

    handleClearFunc() {
      // console.log('--- handleClearFunc ---');

      this.$data.SelectedStartDate = null;
      this.$data.SelectedEndDate = null;
      this.$data.SelectedFirstName = null;
      this.$data.SelectedLastName = null;
      this.$data.SelectedContractNum = null;

      //Clear out the grid records.
      this.GetTrackerRecordsClear();

      //All the AcTextbox components on this page will be initialized
      //by this since the value being set here is used for all instances
      //of the component on this page.
      this.$data.SelectedTextObj = { text: null, time: new Date().getTime() };

      //Clear all validation flags.
      this.ClearValidation();
    },

    handleFirstNameSelected(selectedValue) {
      this.$data.SelectedFirstName = selectedValue;
      // console.log('this.$data.SelectedFirstName = ', this.$data.SelectedFirstName);
    },

    handleLastNameSelected(selectedValue) {
      this.$data.SelectedLastName = selectedValue;
      // console.log('handleLastNameSelected(): selectedValue = ', selectedValue);
    },

    handleContractSelected(selectedValue) {
      this.$data.SelectedContractNum = selectedValue;
      // console.log('handleContractSelected(): selectedValue = ', selectedValue);
    },

    handleSubmitSearchFunc() {
      // console.log('----- handleSubmitSearchFunc -----');

      this.ValidateSearchFields();

      if (this.$data.validationErrorsFound == false) {
        this.GetTrackerRecords();
      }
    },

    // ---------------------------------------------------------------
    // ---------------------- Validation -----------------------------
    // ---------------------------------------------------------------

    ValidateSearchFields() {

      // console.log('----- ValidateSearchFields -----');

      this.ClearValidation();

      this.$data.validationErrorsFound = false;

      if ((this.$data.SelectedStartDate == null) &&
        (this.$data.SelectedEndDate == null) &&
        (this.$data.SelectedLastName == null) &&
        (this.$data.SelectedFirstName == null) &&
        (this.$data.SelectedContractNum == null)) {
        this.$data.validationErrorsFound = true;
        this.$data.allFieldsAreNull = true;
      } else if ((this.$data.SelectedStartDate != null) &&
        ((this.$data.SelectedEndDate != null))) {

        let startDate = new Date(this.$data.SelectedStartDate);
        let endDate = new Date(this.$data.SelectedEndDate);

        if (endDate < startDate) {
          this.$data.validationErrorsFound = true;
          this.endBeforeStart = true;
        }
      }
    },

    ClearValidation() {
      this.$data.validationErrorsFound = false;
      this.$data.allFieldsAreNull = false;
      this.$data.endBeforeStart = false;
    },

    logAllSearchParms() {
      console.log('this.$data.SelectedStartDate = ', this.$data.SelectedStartDate);
      console.log('this.$data.SelectedEndDate = ', this.$data.SelectedEndDate);
      console.log('this.$data.SelectedLastName = ', this.$data.SelectedLastName);
      console.log('this.$data.SelectedFirstName = ', this.$data.SelectedFirstName);
      console.log('this.$data.SelectedContractNum = ', this.$data.SelectedContractNum);

      console.log('---------------------');
      console.log('this.$data.validationErrorsFound = ', this.$data.validationErrorsFound);
      console.log('this.$data.allFieldsAreNull = ', this.$data.allFieldsAreNull);
      console.log('this.$data.endBeforeStart = ', this.$data.endBeforeStart);
    },

  },

}
</script>
  
<style scoped>
/* ---------------------- Containers -------------------- */

.pagesMainDiv {
  margin-top: 0px;
  margin-left: 0px;
  margin-bottom: 0px;
  padding-right: 0px;
  text-align: left;
  width: 100%;
}

.formContainer {
  display: grid;
  grid-template-columns: 410px 410px;
  max-width: 920px;
  min-width: 900px;
}

.formContainerBorder {
  border: 1px solid #ccd9ff;
  padding: 10px;
}

.formContainerMargins {
  margin-bottom: 25px;
}

.leftRightRowContainer {
  display: grid;
  grid-template-columns: 30% 70%;
  grid-template-rows: repeat(4, 45px);
}

/* ---------------------- Page Header -------------------- */
.pageHeader {
  font-size: 24px;
  color: #000099;
}

.divRequiredInstructions {
  color: black;
  font-size: 12px;
  margin-left: 15px;
  margin-bottom: 15px;
  margin-top: 10px;
}

/* ---------------------- Hor and Ver Alignment -------------------- */

.itemHorRightVerCenter {
  display: flex;
  flex-direction: row;
  justify-content: right;
  align-items: center;
}

.itemHorLeftVerCenter {
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: center;
}

/* ---------------------- Sizes -------------------- */

.labelRightMargin {
  margin-right: 10px;
}

/* ---------------------- Controls -------------------- */

.ctrlBorderRadius {
  border: 1px solid #d9d9d9;
  border-radius: 6px;
}

.ctrlDate {
  height: 40px;
  padding: 5px;
}

.ctrlLabel {
  font-weight: bold;
  color: #000099;
}

.fontSizeAll {
  font-size: smaller;
}

.fontSizeBtn {
  font-size: 12px;
}

/* ---------------------- Buttons -------------------- */

.btnCreateProperties {
  margin-top: 15px;
  padding: 6px;
}

.tbdButtonLeftMargin {
  margin-left: 15px;
}

/* ---------------------- Validation -------------------- */

.validationDiv {
  display: flex;
  flex-direction: column;
  justify-content: left;
  align-items: center;

  border: 1px solid darkred;
  width: 70%;
  padding: 25px;
  margin-top: 15px;
  margin-bottom: 15px;
}

.validationHeaderDiv {
  width: 100%;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  color: darkblue;
}

.validationErrorAsterisk {
  margin-left: 2px;
}

    .highlightRed {
        color: #DC143C;
    }

.highlightDarkRed {
  color: darkred;
}

.divRequiredInstructions {
  margin-left: 15px;
  margin-bottom: 15px;
  margin-top: 10px;
}

/* ---------------------- Validation Table -------------------- */

.valTableMargin {
  margin-top: 15px;
  margin: 0 auto;
}

.valCell {
  border-top: 1px #e6e6e6 solid;
  border-bottom: 1px #e6e6e6 solid;
  padding: 8px;
  text-align: left;
}

.valCellLeft {
  border-top: 1px #e6e6e6 solid;
  border-bottom: 1px #e6e6e6 solid;
  border-right: 1px #e6e6e6 solid;
  padding: 8px;
  font-weight: bold;
  color: blue;
  text-align: left;
}

</style>
  